import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;
function api(path) {
  const token = localStorage.getItem('token');
  return fetch(`${API_BASE_URL}${path}`, { headers: { Authorization: `Bearer ${token}` } }).then(async r => {
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.message || d.error || `Request failed (HTTP ${r.status})`);
    return d;
  });
}

export default function MaterialLabelsPage() {
  const { shipmentId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api(`/materials/shipment/${shipmentId}/labels`)
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, [shipmentId]);

  if (loading) return <div style={{ padding: 32, fontFamily: 'sans-serif' }}>Loading…</div>;
  if (error) return <div style={{ padding: 32, fontFamily: 'sans-serif', color: '#b91c1c' }}>Could not load labels: {error}</div>;
  if (!data || !data.shipment) return <div style={{ padding: 32, fontFamily: 'sans-serif' }}>Shipment not found.</div>;

  const { shipment, items } = data;

  return (
    <>
      <div className="no-print" style={{ backgroundColor: '#2d3748', color: 'white', padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ backgroundColor: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>← Back</button>
        <span style={{ flex: 1, fontWeight: 'bold' }}>Material Labels — {shipment.po_number ? `PO ${shipment.po_number}` : 'Shipment'} · {shipment.work_item_title}</span>
        <button onClick={() => window.print()} style={{ backgroundColor: '#3182ce', border: 'none', color: 'white', padding: '8px 18px', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 'bold' }}>🖨 Print All</button>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, padding: 24, backgroundColor: '#f1f5f9' }}>
        {shipment.order_qr_uuid && (
          <div className="print-label" style={{ fontFamily: 'sans-serif', padding: 16, width: 260, border: '2px dashed #166534', borderRadius: 10, textAlign: 'center', backgroundColor: '#f0fdf4', boxSizing: 'border-box' }}>
            <div style={{ fontSize: 13, fontWeight: 'bold', color: '#166534', marginBottom: 6 }}>SCAN TO CHECK OUT WHOLE ORDER</div>
            <img src={`${API_BASE_URL}/material-order-image/${shipment.order_qr_uuid}`} alt="Order QR" style={{ width: 180, height: 180, display: 'block', margin: '0 auto 8px' }} onError={e => { e.target.style.display = 'none'; }} />
            <div style={{ fontSize: 14, fontWeight: 'bold' }}>{shipment.work_item_title}</div>
            {shipment.wo_number && <div style={{ fontSize: 12, color: '#555' }}>WO {shipment.wo_number}</div>}
          </div>
        )}
        {items.map((it, idx) => (
          <div key={it.id} className="print-label" style={{
            fontFamily: 'sans-serif', padding: 16, width: 260, border: '2px solid #2d3748',
            borderRadius: 10, textAlign: 'center', backgroundColor: 'white', boxSizing: 'border-box',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
              <span style={{ fontSize: 14, fontWeight: 'bold', color: '#2d3748' }}>ITEM #{idx + 1}</span>
              <span style={{ fontSize: 12, color: '#666' }}>{it.expected_qty} {it.unit || ''}</span>
            </div>
            <img
              src={`${API_BASE_URL}/material-label-image/${it.qr_uuid}`}
              alt="QR"
              style={{ width: 170, height: 170, display: 'block', margin: '0 auto 8px' }}
              onError={e => { e.target.style.display = 'none'; }}
            />
            <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 2 }}>{it.description}</div>
            {it.part_number && <div style={{ fontSize: 12, color: '#555' }}>{it.part_number}</div>}
            <div style={{ borderTop: '1px solid #e2e8f0', marginTop: 8, paddingTop: 6, fontSize: 11, color: '#888' }}>
              {shipment.wo_number ? `WO ${shipment.wo_number} · ` : ''}{shipment.work_item_title}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: white !important; }
          .print-label { border: 2px solid #000 !important; box-shadow: none !important; page-break-inside: avoid; }
        }
      `}</style>
    </>
  );
}
